module.exports = __webpack_public_path__ + "img/D202007_4.5f0dc3f3.jpg";